import { UseQueryResult } from "@tanstack/react-query";
import { array, option } from "fp-ts";
import { constUndefined, pipe } from "fp-ts/lib/function";

export const parseAllQueryData = <T, U>(queries: UseQueryResult<T, U>[]) =>
  pipe(
    queries,
    option.of,
    option.filter((queries) => !!queries.length),
    option.map(array.map(({ data }) => data)),
    option.filter(array.every((el) => el !== undefined)),
    // TODO: set up arrayOfNullableToNullableArray fn
    option.map(array.map((data) => data as T)),
    option.getOrElseW(constUndefined)
  );
